import type { SVGProps } from "react"

// Custom grass-tuft mark: five tapered blades fanning from a base line.
// Replaces lucide's Sparkles anywhere a "fresh / new lawn" accent is needed.
// Inherits currentColor and sizes via className like any lucide icon.
export function GrassTuft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {/* center blade */}
      <path d="M12 20V7c0-1.5.6-2.9 2-4-.3 1.8-.3 3.2 0 4.6" />
      {/* inner left + right blades */}
      <path d="M8.5 20c-.2-3.6.2-6.8 2-9.5" />
      <path d="M15.5 20c.2-3.6-.2-6.8-2-9.5" />
      {/* outer left + right blades */}
      <path d="M5.5 20c-.4-2.6.3-5 2.2-6.8" />
      <path d="M18.5 20c.4-2.6-.3-5-2.2-6.8" />
      {/* soil line */}
      <path d="M4 20h16" />
    </svg>
  )
}
